import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ProductService } from 'src/app/services/product.service';
import * as _ from "lodash";
import { LoaderService } from 'src/app/shared/services/loader.service';
import { NotificationService } from 'src/app/services/notification-service';
import { ExcelService } from 'src/app/services/excel.service';
import moment from 'moment';
import swal from 'sweetalert2'
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-manage-reseller-product',
    templateUrl: './manage-reseller-product.component.html',
    styleUrls: ['./manage-reseller-product.component.scss']
})
export class ManageResellerProductComponent implements OnInit {
    filterValue: string = ''
    data = [];
    dataSource = new MatTableDataSource(this.data);
    displayedColumns: string[] = [
        "serviceProvider",
        "ProductName",
        "ProductCode",
        "Cost"
    ];

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild("searchInput", { static: true }) searchInput: ElementRef;
    dataExcel: any = [];
    excelColumns: string[];
    form: FormGroup;
    constructor(private productService: ProductService, private loaderService: LoaderService, private toastr: NotificationService, private excelService: ExcelService,
        private fb: FormBuilder
    ) { }

    ngOnInit() {
        this.form = this.fb.group({
            products: this.fb.array([])
        });
        this.getTableData('')
    }

    getTableData(data) {
        if (data) {
            data = { productName: data }
        }
        this.productService.getResellerProducts(data).subscribe((result) => {
            this.products.clear();
            result.forEach(product => this.addProduct(product))
            this.data = [];
            this.dataExcel = [];
            this.data = result;
            this.dataExcel = result;
            this.data = _.orderBy(this.data, ["priority"]);
            this.dataSource = new MatTableDataSource(this.data);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
        });
    }
    get products(): FormArray {
        return this.form.get('products') as FormArray;
    }

    newProduct(data): FormGroup {
        return this.fb.group({
            serviceProvider: [data.serviceProvider],
            productName: [data.productName],
            productCode: [data.productCode],
            productId: [data.productId],
            resellerCost: [data.resellerCost, Validators.required]
        });
    }

    addProduct(data) {
        this.products.push(this.newProduct(data));
    }
    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.filterValue = filterValue;
    }
    clearFilter() {
        const inputElement = document.getElementById('filter-input') as HTMLInputElement;
        if (inputElement) {
            inputElement.value = '';
        }
        this.dataSource.filter = '';
        this.searchInput.nativeElement.value = "";
        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
        this.dataSource.sort.active = '';
        this.dataSource.sort.direction = '';
        this.dataSource.sort.sortChange.emit({ active: '', direction: '' });
        this.getTableData('');
    }
    exportAsXLSX(): void {
        this.loaderService.start();
        setTimeout(() => {
            var exportData = this.dataExcel;
            if (!exportData || exportData.length === 0) {
                this.toastr.showInfo("No data available to export");
                this.loaderService.hide();
                return;
            }
            const excelList = [];
            this.excelColumns = [
                "S.No",
                "FNO",
                'Product Name',
                'Product Code',
                'Cost',
            ];
            exportData.forEach((a, index) => {
                excelList.push({
                    sno: ++index,
                    "FNO": a.serviceProvider,
                    "Product Name": a.productName,
                    "Product Code": a.productCode,
                    "Cost": a.resellerCost
                });
            });
            this.excelService.exportAsExcelFile(excelList, "ManageReseller_Product_" + moment().format("DDMMYYYYHHmmss") + '.xlsx', this.excelColumns);
            this.loaderService.stop();
        }, 500);
    }
    saveResellerProductCost() {
        debugger

        const data = this.form.value.products.map(item => ({
            ...item,
        }));
        this.productService.saveResellerProductCost(data).subscribe((result) => {
            if (result) {
                swal.fire({
                    text: 'Updated Reseller Product Cost successfully!',
                    icon: 'success',
                }).then(res => {
                    if (res.isConfirmed) {
                    }
                })
            }
            else {
                swal.fire({
                    text: 'OOPS!',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    showConfirmButton: true
                }).then(res => {
                    if (res.isConfirmed) {
                    }
                })
            }
        });

    }
}
